import './DeletePhoto.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Error from '../Error/Error';
import Attachment from '../../api/controllers/Attachment/Attachment';

// General DeletePhoto Component
const DeletePhoto = ({ photoId, refetchPhotos, setModalOpen }) => {
  const [error, setError] = useState();

  const deletePhoto = () => {
    Attachment.destroy(photoId)
      .then(() => {
        refetchPhotos();
        setModalOpen(false);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  return (
    <div className="delete_photo_container">
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="message">Are you sure?</div>
      <div className="delete_photo_buttons">
        <button className="cancel_button" onClick={() => setModalOpen(false)}>
          Cancel
        </button>
        <button className="ok_button" onClick={() => deletePhoto()}>
          OK
        </button>
      </div>
    </div>
  );
};

DeletePhoto.propTypes = {
  photoId: PropTypes.number,
  refetchPhotos: PropTypes.func,
  setModalOpen: PropTypes.func,
};

export default DeletePhoto;
